import Link from "next/link";

import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "USF Student Registrations",
    description: (
      <>
        Claim your free student ticket and purchase additional guest tickets for
        the basketball seasons as supplies last. Be sure to login with your
        student email address on file with the registrar&apos;s office.
      </>
    ),
    authRedirectPage: routes.home,
    buttonLabel: "View Available Offers",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer: (
      <>
        Student tickets & additional guest tickets open at 10:00 AM 7 days prior
        to the day of the game.
      </>
    ),
  },
  {
    question: "Do I need a student ID to enter the game?",
    answer: "Yes, please bring your USF ID to the game.",
  },
  {
    question: "How can I access my student tickets?",
    answer: (
      <>
        You can access your student tickets on our South Florida Bulls App:{" "}
        <Link target="_blank" href="https://www.fanthreesixty.com/go-bulls ">
          https://www.fanthreesixty.com/go-bulls
        </Link>
        .
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer: "Yes, limited guests tickets are available at a discount for USF.",
  },
  {
    question:
      "If I purchase more than one guest ticket, will my seats be together?",
    answer:
      "All tickets are general admission in the student sections, you and your friends will have access to the same sections for seats.",
  },
  {
    question: "Can my tickets be transferred to a friend?",
    answer:
      "Your tickets are transferable but not eligible for resale. Abusing these guidelines can result in your pass being revoked.",
  },
  {
    question: "How can I get a refund for my tickets?",
    answer: (
      <>
        Refunds are not guaranteed. Please contact the USF box office at{" "}
        <Link href="mailto:Bullstickets@usf.edu">Bullstickets@usf.edu</Link> or
        text 1-800-GoBulls.
      </>
    ),
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const ADD_ON_PURCHASE_SUCCESS_MESSAGE = {
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => (
    <>
      View your tickets{" "}
      <b>
        <u>
          <Link
            target="_blank"
            style={{
              color: "white",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            href="https://www.fanthreesixty.com/go-bulls"
          >
            here
          </Link>
        </u>
      </b>
      .
    </>
  ),
};
